export default __webpack_public_path__ + "static/media/farmer.ddf0be3c.png";